import React from 'react';


export const HistoryContext = React.createContext();


export default HistoryContext;